export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home',
    visible: []
  },
  {
    text: 'Anleitung',
    path: '/tutorial',
    icon: 'video',
    visible: []
  },
  {
    text: 'Buchungen',
    path: '/bookings',
    icon: 'car',
    visible: []
  },
  {
    text: 'Fahrer',
    path: '/drivers',
    icon: 'group',
    visible: ['Admin']
  },
  {
    text: 'Rechnungen',
    path: '/invoices',
    icon: 'description',
    visible: ['Admin']
  },
  {
    text: 'Preisliste',
    path: '/pricelist',
    icon: 'money',
    visible: ['Admin', 'Moll', 'Disponent', 'Fex']
  },
  {
    text: 'Hinweise',
    path: '/info',
    icon: 'info',
    visible: []
  },
  {
    text: 'Kontakte',
    path: '/contact',
    icon: 'tel',
    visible: []
  },
  // {
  //   text: 'Einstellungen',
  //   path: '/',
  //   icon: 'optionsgear'
  // },
  // {
  //   text: 'Profil',
  //   path: '/profile',
  //   icon: 'user'
  // },

  // {
  //   text: 'Examples',
  //   icon: 'folder',
  //   items: [
  //     {
  //       text: 'Profile',
  //       path: '/profile'
  //     },
  //     {
  //       text: 'Bookings',
  //       path: '/bookings'
  //     }
  //   ]
  // }
  ];
